// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__sBu62","iconWithCounter":"styles_iconWithCounter__vxXuV","counterForLabel":"styles_counterForLabel__IoW9y","counterForIcon":"styles_counterForIcon__HwxlX"};